import axios from "axios";
import { API_BASE } from "../../../config/api";

export const fetchMovies = async (gameMode, level = 1) => {
  let endpoint;
  switch (gameMode) {
    case "normal":
      endpoint = `${API_BASE}/api/randomMovies`;
      break;
    case "hard":
      endpoint = `${API_BASE}/api/randomMoviesWithRange`;
      break;
    case "daily":
      endpoint = `${API_BASE}/api/dailyGame/${level}`;
      break;
    default:
      throw new Error(`Unknown game mode: ${gameMode}`);
  }
  const response = await axios.get(endpoint);
  return response.data;
};


export const handleGuess = ({
  selectedIndex,
  level,
  movies,
  score,
  wrongGuesses,
  wrongGuessRounds,
  setScore,
  setWrongGuesses,
  setWrongGuessRounds,
  setGameOver,
  saveScore,
  setMessage,
  setHasMadeChoice,
  fetchNextMovies,
}) => {
  if (movies.length < 2) return;

  const [movie1, movie2] = movies;
  const correctIndex =
    parseFloat(movie1.vote_average) > parseFloat(movie2.vote_average) ? 0 : 1;

  if (selectedIndex === correctIndex) {
    setMessage("Correct!");
    setScore(score + 1);
    setWrongGuessRounds(prev => [...prev, Number(level)]);
  } else {
    setMessage("Incorrect!");
    const newWrong = wrongGuesses + 1;
    setWrongGuesses(newWrong);
    setWrongGuessRounds(prev => [...prev, Number(level) * -1]);
    if (newWrong >= 3) {
      setGameOver(true);
      saveScore(score);
    } else {
      setTimeout(fetchNextMovies, 1000);
    }
  }

  setHasMadeChoice(true);
  setTimeout(fetchNextMovies, 1000);
};
